const rewardParser = (value: string | undefined): string =>
  value ? value.replace(/\$\s?|(,*)/g, '') : '';
export { rewardParser };
